<div class="register-container">
  <div class="background">
    <div class="gradient-overlay"></div>
    <div class="particles">
      <div class="particle particle-1"></div>
      <div class="particle particle-2"></div>
      <div class="particle particle-3"></div>
      <div class="particle particle-4"></div>
      <div class="particle particle-5"></div>
    </div>
  </div>

  <div class="register-panel">
    <div class="register-panel-left">
      <div class="brand-logo">
        <svg viewBox="0 0 24 24" class="logo-icon">
          <path
            d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
          ></path>
        </svg>
        <span class="logo-text">Markado</span>
      </div>
      <div class="illustration">
        <div class="illustration-circle"></div>
        <div class="illustration-shape shape-1"></div>
        <div class="illustration-shape shape-2"></div>
        <div class="illustration-shape shape-3"></div>
      </div>
      <div class="welcome-text">
        <h1>Almost there!</h1>
        <p>Complete your profile to continue with {{ provider }} login</p>
      </div>
    </div>

    <div class="register-panel-right">
      <div class="register-header">
        <h2>Complete Your Registration</h2>
        <p>We need a few more details to set up your account</p>
      </div>

      <form
        [formGroup]="registerForm"
        (ngSubmit)="onSubmit()"
        class="register-form"
      >
        <div class="form-row">
          <div
            class="form-group"
            [class.form-error]="
              first_name?.invalid && (first_name?.dirty || first_name?.touched)
            "
          >
            <label for="first_name">First Name</label>
            <div class="input-wrapper">
              <svg class="input-icon" viewBox="0 0 24 24">
                <path
                  d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                ></path>
              </svg>
              <input
                type="text"
                id="first_name"
                formControlName="first_name"
                placeholder="John"
                [class.is-invalid]="
                  first_name?.invalid &&
                  (first_name?.dirty || first_name?.touched)
                "
              />
            </div>
            <div
              class="error-text"
              *ngIf="
                first_name?.invalid &&
                (first_name?.dirty || first_name?.touched)
              "
            >
              <div *ngIf="first_name?.errors?.['required']">
                First name is required
              </div>
              <div *ngIf="first_name?.errors?.['minlength']">
                First name must be at least 2 characters
              </div>
            </div>
          </div>

          <div
            class="form-group"
            [class.form-error]="
              last_name?.invalid && (last_name?.dirty || last_name?.touched)
            "
          >
            <label for="last_name">Last Name</label>
            <div class="input-wrapper">
              <svg class="input-icon" viewBox="0 0 24 24">
                <path
                  d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                ></path>
              </svg>
              <input
                type="text"
                id="last_name"
                formControlName="last_name"
                placeholder="Doe"
                [class.is-invalid]="
                  last_name?.invalid && (last_name?.dirty || last_name?.touched)
                "
              />
            </div>
            <div
              class="error-text"
              *ngIf="
                last_name?.invalid && (last_name?.dirty || last_name?.touched)
              "
            >
              <div *ngIf="last_name?.errors?.['required']">
                Last name is required
              </div>
              <div *ngIf="last_name?.errors?.['minlength']">
                Last name must be at least 2 characters
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="email"
            >Email (Verified by {{ provider || "OAuth Provider" }})</label
          >
          <div class="input-wrapper">
            <svg class="input-icon" viewBox="0 0 24 24">
              <path
                d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
              ></path>
            </svg>
            <input
              type="email"
              id="email"
              formControlName="email"
              placeholder="you@example.com"
              style="
                background-color: #f3f4f6;
                color: #6b7280;
                cursor: not-allowed;
              "
              readonly
              tabindex="-1"
            />
          </div>
        </div>

        <div class="form-group">
          <label for="phone_number">Phone Number (Optional)</label>
          <div class="phone-input-wrapper">
            <div class="country-code-dropdown">
              <select
                id="country_code"
                formControlName="country_code"
                class="country-select"
                aria-label="Country code"
              >
                <option
                  *ngFor="let country of countryCodes"
                  [value]="country.dialCode"
                >
                  {{ country.code }} {{ country.dialCode }}
                </option>
              </select>
              <div class="dropdown-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </div>
            </div>

            <div class="phone-input">
              <input
                type="tel"
                id="phone_number"
                formControlName="phone_number"
                placeholder="Phone number"
                class="phone-number-input"
                [class.is-invalid]="
                  phone_number?.invalid &&
                  (phone_number?.dirty || phone_number?.touched)
                "
              />
            </div>
          </div>
          <div
            class="error-text"
            *ngIf="
              phone_number?.invalid &&
              (phone_number?.dirty || phone_number?.touched)
            "
          >
            <div *ngIf="phone_number?.errors?.['pattern']">
              Please enter digits only (no spaces, dashes or other characters)
            </div>
            <div *ngIf="phone_number?.errors?.['invalidNumber']">
              Invalid phone number format for {{ selectedCountry?.name }}
            </div>
          </div>
          <div class="phone-help-text">
            <small>Example: {{ getPhoneExampleNumber() }}</small>
          </div>
        </div>

        <div class="form-group">
          <div class="marketing-consent-wrapper">
            <label class="checkbox-container" for="marketing_consent">
              <input
                type="checkbox"
                id="marketing_consent"
                formControlName="marketing_consent"
                class="checkbox-input"
              />
              <span class="checkmark"></span>
              <span class="checkbox-text">
                I would like to receive marketing emails, newsletters, and
                promotional offers from Markado
              </span>
            </label>
          </div>
        </div>

        <div class="alert alert-error" *ngIf="errorMessage">
          <svg class="alert-icon" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          <span>{{ errorMessage }}</span>
        </div>

        <div *ngIf="successMessage" class="success-overlay">
          <div class="success-modal">
            <div class="success-icon-container">
              <svg class="success-icon" viewBox="0 0 24 24">
                <path
                  class="success-icon-circle"
                  d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z"
                ></path>
                <path
                  class="success-icon-check"
                  d="M7.8,13.2l2.8,2.8l5.6-5.6"
                ></path>
              </svg>
            </div>
            <h3 class="success-title">Welcome!</h3>
            <p class="success-message">{{ successMessage }}</p>
            <div class="success-progress">
              <div class="success-progress-bar"></div>
            </div>
          </div>
        </div>

        <button
          type="submit"
          class="signin-button"
          [disabled]="isSubmitting || registerForm.invalid"
        >
          <span *ngIf="!isSubmitting">Complete Registration</span>
          <div class="spinner" *ngIf="isSubmitting">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
        </button>

        <div class="signup-prompt">
          <span>Need to use a different account?</span>
          <a routerLink="/login" class="signup-link">Back to Login</a>
        </div>
      </form>
    </div>
  </div>
</div>
